import { IconType } from "react-icons";
import { FaSmile, FaTshirt, FaRunning } from "react-icons/fa";
import { FaHourglassHalf, FaGlobe, FaScissors, FaEye, FaPersonDress, FaCamera, FaCity, FaUser } from "react-icons/fa6";
import { AttributeKey } from "./characterTypes";

export const transformKeyToTitle = (key: string) => {
  return key
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char, index) =>
      index === 0 ? char.toUpperCase() : char.toLowerCase(),
    );
};

export const iconMapping: { [key in AttributeKey]: IconType | null } = {
  age: FaHourglassHalf,
  origin: FaGlobe,
  hairColor: FaScissors,
  hairStyle: FaScissors,
  faceType: FaSmile,
  eyeColor: FaEye,
  bodyType: FaPersonDress,
  boobs: FaPersonDress,
  clothing: FaTshirt,
  place: FaCamera,
  composition: FaCity,
  action: FaRunning,
  persona: FaUser,
  name: FaUser,
  gender: FaUser,
  _imageUrl: null,
};